import React from 'react';

interface IndividualResourceInvoiceTableProps {
  data: Array<IndividualResourceInvoiceData>;
  className?: string;
}

const IndividualResourceInvoiceTable: React.FC<
  IndividualResourceInvoiceTableProps
> = ({ data, className }) => {
  const headers = ['발전소명', '용량 (MW)', '발전량 (MWh)', '인센티브 (원)'];
  return (
    <table className={`${className} w-full`}>
      <thead>
        <tr className="h-[36px] rounded-[5px] bg-[#1F384C] text-white">
          {headers.map((value, index) =>
            index === 0 ? (
              <th
                key={index}
                className="noto-12-normal rounded-bl-[5px] rounded-tl-[5px]"
              >
                {value}
              </th>
            ) : index === headers.length - 1 ? (
              <th
                key={index}
                className="noto-12-normal rounded-br-[5px] rounded-tr-[5px]"
              >
                {value}
              </th>
            ) : (
              <th key={index} className="noto-12-normal">
                {value}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {data.map((value, index) => (
          <tr key={index} className="border-b border-[#E2E7E7]">
            {Object.keys(value).map((key) => (
              <td
                className="noto-13-normal py-[13px] text-center leading-none text-dark-6"
                key={key + index}
              >
                {value[key as keyof IndividualResourceInvoiceData] ?? '-'}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default IndividualResourceInvoiceTable;
